
import { server } from "../utils/server";

const updateDLTCreationStatusHUF = (data) =>{
    return server.post("/huf/features/updateDLTCreationStatus",data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err)
    });
}
const createBlockChainAcc = (data) =>{
    return server.post("huf/features/createWallet",data)
    .then(res=>{
        
        return res.data;
    })
    .catch(err=>{
        console.log(err);
        return null;
    })
}

const getDltWalletOfHuf = (hufId) => {
    return server.get(`huf/auth/getDltWallet/${hufId}`)
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return null;
        })
}

const getDltWallet=(id)=>{
    return server.get(`/huf/features/getDltWallet/${id}`)
    .then((res)=>{
        return res.data;
    })
    
}
 export default {
    updateDLTCreationStatusHUF,
    createBlockChainAcc,
    getDltWalletOfHuf,
    getDltWallet

}